import { Badge } from '@/components/ui/badge';
import type { OrderStatus } from '@/types';

const statusColors: Record<OrderStatus, string> = {
  PENDING_PAYMENT: 'bg-yellow-100 text-yellow-800',
  PAID: 'bg-blue-100 text-blue-800',
  SHIPPED: 'bg-purple-100 text-purple-800',
  DELIVERED: 'bg-green-100 text-green-800',
  CANCELED: 'bg-red-100 text-red-800',
  REFUNDED: 'bg-gray-100 text-gray-800',
};

const statusLabels: Record<OrderStatus, string> = {
  PENDING_PAYMENT: 'Төлбөр хүлээгдэж байна',
  PAID: 'Төлөгдсөн',
  SHIPPED: 'Илгээсэн',
  DELIVERED: 'Хүргэгдсэн',
  CANCELED: 'Цуцлагдсан',
  REFUNDED: 'Буцаагдсан',
};

interface OrderStatusBadgeProps {
  status: OrderStatus;
}

export function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
  return (
    <Badge className={statusColors[status]}>
      {statusLabels[status]}
    </Badge>
  );
}

